/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "points-earn-management",
	data() {
		return {
			productsAndPointsToEarn: [],
			productsAndPointsToEarnHeadings: [
				{
					text: "Product ID",
					field: "productId"
				},
				{
					text: "Barcode",
					field: "productBarcode"
				},
				{
					text: "Name",
					field: "productName"
				},
				{
					text: "Formula",
					field: "pointsFormulaDescription"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				gender: 0,
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getProductsAndPointsToEarn(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
			};
			rewardsService.getProductPointValuesEarnings(request).then(response => {
				if(response.status === 200){
					this.productsAndPointsToEarn = response.data.result;
					if(response.data.pagingInfo !== null){
						this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
					}
					this.productsAndPointsToEarn = dataTableHelper.castFieldValues(this.productsAndPointsToEarn);
					this.filterStateChanged = false;
				}
				this.loading = false;
			});
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getProductsAndPointsToEarn();
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getProductsAndPointsToEarn();
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Points Management - Earn");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Points Management - Earn");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getProductsAndPointsToEarn();
	}
};